import { render, staticRenderFns } from "./HomesForRent.vue?vue&type=template&id=6ff35c06&scoped=true&"
import script from "./HomesForRent.vue?vue&type=script&lang=ts&"
export * from "./HomesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff35c06",
  null
  
)

export default component.exports